import React, {Component} from "react";
import api from "../../../api";
import {withTranslation} from "react-i18next";
import {Button, Form, Header, Icon, Modal} from "semantic-ui-react";
import {Link} from "react-router-dom";

class CancelModal extends Component {

    constructor() {
        super()
        this.state = {
            message: ""
        }
    }

    handleChange = (e) => {
        this.setState({message: e.target.value})
    }

    handleReject = () => {
        api.updateState("eSubcontractorRejected", this.state.message)
    }

    render() {
        const {t} = this.props;

        return (
            <Modal open={true} basic size="small">
                <Header icon='archive' content={t("job.decline")} />
                <div className="pv3">
                    <p>{t("job.declineReason")}</p>
                    <Form>
                        <Form.TextArea label=''
                                       value={this.state.message}
                                       onChange={this.handleChange}
                                       placeholder={t("general.comment")}/>
                    </Form>
                </div>
                <div>
                    <Link to="/accept/new"><Button basic inverted>
                        <Icon name='chevron left'/> {t("general.back")}
                    </Button></Link>
                    <Link disabled={(this.state.message.length < 5)} onClick={this.handleReject} to="/accept/new">
                        <Button type="button" color='red' inverted><Icon
                            name='checkmark'/>{t("general.decline")}</Button>
                    </Link>
                </div>
            </Modal>
        )
    }
}

export default withTranslation()(CancelModal);


// WEBPACK FOOTER //
// ./src/pages/components/Modals/CancelModal.js